import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { trpc } from "@blis/trpc/react";

import { ConfirmPrompt } from "@/components/ConfirmPrompt";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/toast";

export function DeleteAuthProviderButton({ id }: { id: number }) {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const navigate = useNavigate();

  const deleteProvider = trpc.admin.auth.delete.useMutation({
    onSuccess() {
      navigate({ to: "/admin/auth" });
      toast.success("Provider deleted successfully");
    },
    onError(err) {
      toast.error("Error deleting provider", {
        description: err.message,
      });
    },
  });

  return id ? (
    <>
      <Button
        type="button"
        variant="destructive"
        onPress={() => setDeleteOpen(true)}
      >
        Delete
      </Button>
      <ConfirmPrompt
        danger
        title="Delete auth provider"
        message="Are you sure you want to delete this provider?"
        open={deleteOpen}
        loading={deleteProvider.isPending}
        onOpenChange={setDeleteOpen}
        onConfirm={() => deleteProvider.mutate({ id })}
      />
    </>
  ) : null;
}
